import { render, staticRenderFns } from "./Page3Order.vue?vue&type=template&id=21ac6746&scoped=true"
import script from "./Page3Order.vue?vue&type=script&lang=js"
export * from "./Page3Order.vue?vue&type=script&lang=js"
import style0 from "./Page3Order.vue?vue&type=style&index=0&id=21ac6746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac6746",
  null
  
)

export default component.exports